import { render, staticRenderFns } from "./ConversationPanelMenu.vue?vue&type=template&id=11169544&scoped=true&"
import script from "./ConversationPanelMenu.vue?vue&type=script&lang=js&"
export * from "./ConversationPanelMenu.vue?vue&type=script&lang=js&"
import style0 from "./ConversationPanelMenu.vue?vue&type=style&index=0&id=11169544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11169544",
  null
  
)

export default component.exports